<div *ngIf="!strValidTime" class="bg-th-blue mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>

        <i class="fa fa-question-circle text-light my-auto fa-2x" (click)="guid()"></i>


    </div>

</div>

<!-- نوع خودرو -->

<div class="position-absolute index d-flex justify-content-center flex-warp" style="right: 0; left: 0;" *ngIf="!Plak && !bCarList && bShowOptions">

    <div class="col-6 col-md-3 form-check d-flex flex-row mt-1">

        <div class="col-12">

            <select class="form-select text-center" id="groupCar" (change)="liveGetCar()">

                <option value="-1"> نوع خودرو </option>

                <option *ngFor="let item of groupCar" value="{{item.tiMobileType}}">{{item.strComment}}</option>

            </select>

        </div>

    </div>

    <div class="col-6 col-md-3 form-check d-flex flex-row mt-1">

        <div class="col-12">

            <select class="form-select text-center" id="domain" (change)="liveGetCar()">

                <option value="-1"> حوزه خدمت </option>

                <option *ngFor="let item of domain" value="{{item.iMobileDomain}}">{{item.strComment}}</option>

            </select>

        </div>

    </div>

</div>

<!-- مشخصات خودرو خودرو -->

<ng-container *ngIf="!strValidTime">

    <div *ngIf="Name" class="d-flex justify-content-center w-100 mt-3">
    
        <div class=" px-3 rounded text-white index bg-primary position-absolute f14">
    
            <p class="my-0 py-1 f22">
    
                <span>{{Name}}</span>
    
            </p>
    
        </div>
    
    </div>
    
    <!-- زمان -->
    
    <div *ngIf="strTime" class="d-flex justify-content-center w-100 mt-3">
    
        <div class="px-md-3 px-2 text-white index bg-primary position-absolute f14 bl">
    
            <p class="my-0 py-1 f22 dirI"><span> {{strTime}}</span></p>
    
        </div>
    
    </div>
    
    <!-- پیمایش -->
    
    <div *ngIf="!bCarList" class="d-flex justify-content-center w-100 mt-3">
    
        <div class="px-md-3 px-3 text-white index bg-warning position-absolute f14 bottom-0">
    
            <p class="my-0 py-1 f22 dirI text-dark" *ngIf="(fDistance|| fDistance =='0') && iTempAccess == 0 ">
    
                <ng-container *ngIf="Id == 'trackAll';else notTrackAll">
    
                    <span class="text-dark" *ngIf="lastCallTime"> {{lastCallTime.split(' ')[1]}} </span>
    
                </ng-container>
    
                <ng-template #notTrackAll>
    
                    (km) {{fDistance | number}}
    
                </ng-template>
    
            </p>
    
        </div>
    
    </div>
    
    <!-- سرعت -->
    
    <div class="d-flex justify-content-center w-100 mt-3">
    
        <div class="px-md-3 px-2 text-white index bg-success position-absolute f14 br">
    
            <p class="my-0 py-1 f22 dirI" *ngIf="speed ||speed=='0'">
    
                <span>(km/h) {{speed}}</span>
    
            </p>
    
        </div>
    
    </div>

</ng-container>

<!-- dot-one -->

<div class="row gx-0 gy-0 p-0" dir="rtl">

    <!-- دوربین -->

    <ng-container *ngIf="bDashCam" >

        <div class="col-12">
    
            <div class="w-100 p-1" [ngStyle]="{'height': bDotOneMap ? 'calc(100vh / 2)' : 'calc(100vh)' }">
    
                <div class="w-100 h-100">
    
                    <ng-container *ngIf="!lst_checked[0]?.strUnitId">
    
                        <img src="../../../assets/Img/video-thumb.png" alt="دوربین یک">
    
                    </ng-container>
    
                    <ng-container *ngIf="lst_checked[0]?.strUnitId">
    
                        <stream-loader [obj_Camera]="lst_checked[0]" 

                            [isHideInfo]="true"

                            [tripId]="tripId"

                            [tiChannel]="tiChannel"
                            
                            [ScreenShot]="ScreenShot"

                            [expiresAt]="strValidTime"
                        
                            (updateChecked)="updateCheckedList($event)" 
                            
                            (hideComponent)="failedRequest($event)">
    
                        </stream-loader>
    
                    </ng-container>
    
                </div>
    
            </div>
    
        </div>

    </ng-container>

    <!-- نقشه -->

    <div class="col-12" [ngStyle]="{'display': bDotOneMap ? 'initial' : 'none' }">

        <div id="test" class="w-100" [ngStyle]="{'height': bDashCam ? 'calc(100dvh / 2)' : bCarList ? 'calc(93dvh / 1)' : 'calc(85dvh / 1)'}">

            <!-- fixed-map3 -->

            <div id="popup"></div>

            <div class="position-absolute" data-bs-html="true" id="map_tooltips">

            </div>

            <div class="position-absolute" data-bs-html="true" id="map_tooltip">

            </div>

        </div>

    </div>

</div>

<!-- تغییر نوع نقشه -->

<ng-container *ngIf="!strValidTime">

    <img src="../../../assets/Img/layer-icon.png" 
    
        title="تغییر نوع نقشه" 
    
        (click)="changeTail()" style="top: 62px;right: 10px;" 
    
        class="bg-third p-2 circel-2 my-1 text-center pointer text-white 
        
        icon-Img r-0 index position-absolute">

</ng-container>
